export const apificate = state => {
  let {
    code,
    description,
    /*
    postalCode,
    street,
    town,
    city,
    country,
    */
    name,
    firstname,
    lastname
  } = state
  let {
    street,
    postalCode,
    town,
    city,
    country
  } = state.address
  return code || description
          ? {
            code,
            description,
            address: {
              street,
              postalCode,
              town,
              city,
              country
            },
            name,
            firstname,
            lastname
          }
          : undefined
}
